// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { useContext } from 'react';
import { ContractTemplateContext } from '../../../../Service/Context/ContractTemplateContext';
import { BookitupEntity } from '../../../../Service/FileS';
import { openFilePickerModal } from '../../../Dialogs/FilePickerModal';
import BookitupEntityPreview from '../../../../Atoms/BookitupEntityPreview';

const ContractPdfSection = () => {
  const { template, savePatch } = useContext(ContractTemplateContext);
  if (!template) {
    return null;
  }
  const {
    profileId,
    frontCoverFileName,
    frontCoverEntityId,
    frontCoverEntityType,
    backCoverEntityId,
    backCoverEntityType,
    backCoverFileName,
  } = template;

  return (
    <>
      <Text weight="bolder" size="lg" mb="md">
        PDFs beifügen
      </Text>
      <Text mb="md">Fügen Sie dem Vertrag ein beliebiges PDF bei </Text>

      {frontCoverFileName && (
        <BookitupEntityPreview
          entityId={frontCoverEntityId}
          entityType={frontCoverEntityType}
          filename={frontCoverFileName}
          onDelete={() => savePatch({ frontCoverFileName: null })}
        />
      )}
      {!frontCoverFileName && (
        <Text
          color="blue"
          variant="link"
          sx={{ cursor: 'pointer', width: 180 }}
          onClick={() =>
            openFilePickerModal({
              profileId: profileId.toString(),
              onSelect: (entity: BookitupEntity) => {
                const { entityId, entityType, fileName } = entity;
                savePatch({
                  frontCoverEntityId: entityId,
                  frontCoverEntityType: entityType,
                  frontCoverFileName: fileName,
                });
              },
              allowedExtensions: ['pdf'],
            })
          }
        >
          + PDF-Datei auswählen
        </Text>
      )}
      <Text size="xs" color="dimmed" mb="md">
        Wähle eine PDF-Datei, die{' '}
        <Text span weight="bolder">
          {' '}
          vor
        </Text>{' '}
        dem Dokument eingefügt werden soll
      </Text>
      {backCoverFileName && (
        <BookitupEntityPreview
          entityId={backCoverEntityId}
          entityType={backCoverEntityType}
          filename={backCoverFileName}
          onDelete={() => savePatch({ backCoverFileName: null })}
        />
      )}
      {!backCoverFileName && (
        <Text
          color="blue"
          variant="link"
          sx={{ cursor: 'pointer', width: 180 }}
          onClick={() =>
            openFilePickerModal({
              profileId: profileId.toString(),
              onSelect: (entity: BookitupEntity) => {
                const { entityId, entityType, fileName } = entity;
                savePatch({
                  backCoverEntityId: entityId,
                  backCoverEntityType: entityType,
                  backCoverFileName: fileName,
                });
              },
              allowedExtensions: ['pdf'],
            })
          }
        >
          + PDF-Datei auswählen
        </Text>
      )}
      <Text size="xs" color="dimmed">
        Wähle eine PDF-Datei, die{' '}
        <Text span weight="bolder">
          {' '}
          nach
        </Text>{' '}
        dem Dokument eingefügt werden soll
      </Text>
    </>
  );
};

export default ContractPdfSection;
